import {
  Directive, OnDestroy, HostBinding, EventEmitter
} from '@angular/core';

import { takeUntil } from 'rxjs/operators';

import { BreakpointsService } from '@sondermind/utilities/services';

@Directive({
  selector: '[sondermindMediaQueryAttribute]',
  standalone: false
})
export class MediaQueryAttributeDirective implements OnDestroy {
  private destroyed$ = new EventEmitter<void>();

  @HostBinding('attr.data-mediaquery')
    matchedQueryValues: string;

  constructor(
    breakpoints: BreakpointsService,
  ) {
    breakpoints.suffixes$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((suffixes) => {
      this.matchedQueryValues = suffixes.join(' ');
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }
}
